export var CreatorStatus;
(function (CreatorStatus) {
    CreatorStatus["PENDING"] = "pending";
    CreatorStatus["APPROVED"] = "approved";
    CreatorStatus["REJECTED"] = "rejected";
    CreatorStatus["SUSPENDED"] = "suspended";
    CreatorStatus["INACTIVE"] = "inactive";
})(CreatorStatus || (CreatorStatus = {}));
export var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["UNVERIFIED"] = "unverified";
    VerificationStatus["PENDING"] = "pending";
    VerificationStatus["VERIFIED"] = "verified";
    VerificationStatus["REJECTED"] = "rejected";
})(VerificationStatus || (VerificationStatus = {}));
export var PayoutMethod;
(function (PayoutMethod) {
    PayoutMethod["PAYPAL"] = "paypal";
    PayoutMethod["STRIPE"] = "stripe";
    PayoutMethod["BANK_TRANSFER"] = "bank_transfer";
})(PayoutMethod || (PayoutMethod = {}));
